import PropTypes from 'prop-types';

export const LabelDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    '../store/Label/Label.dispatcher'
);

const propTypes = (member) => ({
    ...member,
    fetchLabels: PropTypes.func.isRequired
});

const mapDispatchToProps = (args, callback, _instance) => {
    const [dispatch] = args;

    return {
        ...callback(...args),
        fetchLabels: async () =>
            LabelDispatcher.then(
                ({ default: dispatcher }) => dispatcher.handleData(dispatch)
            )
    }
}

const initializeApplication = (args, callback, instance) => {
    const { fetchLabels } = instance.props;

    fetchLabels();

    return callback(...args)
}

export default {
    'Bookland/Component/Router/Container': {
        'static-member': {
            propTypes
        },
        'member-function': {
            initializeApplication
        }
    },
    'Bookland/Component/Router/Container/mapDispatchToProps': {
        function: mapDispatchToProps
    }
}
